<template>
    <div class="aboutMy">
        <!--banner start-->
        <div class="about_banner"></div>
        <!--banner end-->

        <!--公司介绍 start-->
        <div class="company_introduction">
            <div class="contentWidth">
                <h2 class="about_my_title">公司介绍</h2>
                <p>西安智徽信息工程有限公司成立于2007年12月，是集研发、销售、客服、咨询于一体的人口健康信息化整体解决方案供应商，拥有高端开发人才30余人。</p>
                <p>智徽软件产品服务于西安市、安康市、商洛市、西咸新区、渭南市、宝鸡市等地区4千余家卫生院与村卫生室基层医疗机构、100余家县级以上综合医疗机构、40余家卫生管理部门、超过500万城乡居民。</p>
                <p>公司秉承“科技服务健康”的理念，致力于推动人口健康信息化产业发展，通过“互联网+健康医疗”探索服务新模式，促进医疗健康大数据的应用；持续开展前沿技术及业务研究，推动业务创新，已构建了人口健康、综合医疗、全民医保、公共卫生、卫生监管等基础产品群，为政府、医疗机构、亿万居民提供健康信息化服务，为打造健康中国提供有力支撑。</p>
            </div>

        </div>
        <!--公司介绍 end-->

        <!--企业文化 start-->
        <div class="corporate_culture">
            <div class="contentWidth">
                <h2 class="about_my_title">企业文化</h2>
                <ul class="ly_flex ly_flex_just_between">
                    <li class="culture_list ly_flex ly_flex_col ly_flex_ali_center"
                        v-for="item in cultureList"
                        :key="item.key">
                        <img class="culture_icon" :src="item.icon" alt="">
                        <p class="culture_name">{{item.name}}</p>
                        <p class="culture_introduce" :style="{width:item.width}">{{item.introduce}}</p>
                    </li>
                </ul>
            </div>
        </div>
        <!--企业文化 end -->

        <!--知识产权 start-->
        <div class="intellectual_property">
            <div class="contentWidth">
                <h2 class="about_my_title">知识产权</h2>
                <ul class="ly_flex ly_flex_wrap_wrap ly_flex_just_between">
                    <li class="property_list" v-for="item in propertyList" :key="item.key">
                        <img :src="item.imgPath" alt="">
                        <p>{{item.title}}</p>
                    </li>
                </ul>
            </div>
        </div>
        <!--知识产权 end-->
    </div>
</template>

<script>
    export default {
        name: "aboutMy",
        data(){
            return{
                cultureList:[
                    {
                        icon:require('@/assets/img/culture1.png'),
                        name:'企业精神',
                        introduce:'提供更多先进技术',
                        width:'145px'
                    },
                    {
                        icon:require('@/assets/img/culture2.png'),
                        name:'企业使命',
                        introduce:'让人人享有便捷的健康服务',
                        width:'144px'
                    },
                    {
                        icon:require('@/assets/img/culture3.png'),
                        name:'企业愿景',
                        introduce:'搭建智能便捷的健康服务生态系统，成为员工实现自我价值的平台',
                        width:'199px'
                    },
                    {
                        icon:require('@/assets/img/culture4.png'),
                        name:'核心价值观',
                        introduce:'城信务实  合作开放 勇于创新  团队协作',
                        width:'155px'
                    },
                ],
                propertyList:[
                    {
                        imgPath:require('@/assets/img/property1.png'),
                        title:'智徽慢性病精细化管理平台'
                    },
                    {
                        imgPath:require('@/assets/img/property2.png'),
                        title:'智徽城乡一体化医疗结算监管平台'
                    },
                    {
                        imgPath:require('@/assets/img/property3.png'),
                        title:'智徽城乡一体化医疗保险管理平台'
                    },
                    {
                        imgPath:require('@/assets/img/property4.png'),
                        title:'智徽城乡医疗综合信息服务平台'
                    },
                    {
                        imgPath:require('@/assets/img/property5.png'),
                        title:'智徽家庭医生签约服务管理平台'
                    },
                    {
                        imgPath:require('@/assets/img/property6.png'),
                        title:'智徽健康管理APP软件'
                    },
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    .aboutMy {
        .about_banner {
            width: 100%;
            height: 306px;
            background: url("../../../public/img/aboutMy/about_banner.png");
            background-size: 100% 100%;
        }

        .about_my_title {
            margin-bottom: 70px;
            text-align: center;
            font-size: 40px;
            line-height: 40px;
            font-weight: 600;
            color: #333333;
        }

        /*公司介绍*/
        .company_introduction {
            padding-top: 70px;
            width: 100%;
            height: 450px;

            p {
                margin-bottom: 20px;
                font-size: 16px;
                line-height: 32px;
                letter-spacing: 0.8px;
                color: #444444;
            }
        }

        /*企业文化*/
        .corporate_culture {
            padding-top: 97px;
            width: 100%;
            height: 583px;
            background: #F8F8F8;

            .about_my_title {
                margin-bottom: 60px;
            }

            .culture_list {
                padding-top:52px;
                width: 282px;
                height: 270px;
                background: #ffffff;
                .culture_icon{
                    margin-bottom: 33px;
                    width:80px;
                    height: 80px;
                }
                .culture_name{
                    margin-bottom: 35px;
                    font-size:24px;
                    line-height: 24px;
                    color:#333333;
                }
                .culture_introduce{
                    text-align: center;
                    font-size:18px;
                    line-height: 30px;
                    color:#333333;
                }
            }
        }


        /*知识产权*/
        .intellectual_property{
            width:100%;
            padding: 98px 0  168px;
            .about_my_title{
                margin-bottom: 77px;
            }

            .property_list{
                width: 341px;
                img{
                    width: 351px;
                    height: 477px;
                }
                p{
                    padding:28px 0 60px;
                    text-align: center;
                    font-size: 22px;
                    line-height: 22px;
                    color:#333333;
                }
            }
        }
    }
</style>